import createCallbackWithTimeout from "./createCallbackWithTimeout";
import { ConversionItemModel } from "..";

/**
 * Declare a `dataLayer` property on the window used by Google Tag Manager so we can add things to it.
 * https://developers.google.com/tag-manager/devguide
 */
declare global {
    interface Window {
        dataLayer?: object[];
    }
}

/**
 * Pushes variables to the GTM dataLayer.
 * See https://developers.google.com/tag-manager/devguide#multipush and https://developers.google.com/tag-manager/reference#datalayer.push
 */
export default function push(
    event: string,
    variables: Record<string, string | number | ConversionItemModel[] | null>
): Promise<void> {
    // A promise that gets resolved when the callback is completed for `dataLayer` below
    return new Promise(resolve => {
        // If dataLayer is present
        if (!window.dataLayer) {
            // If dataLayer isn't present, Google Tag Manager has not been set up for this promotion.
            // Nothing to do:
            resolve();
            return;
        }

        const eventTimeout = 2000;
        const eventCallback = createCallbackWithTimeout(resolve, eventTimeout);

        window.dataLayer.push({
            event,
            eventCallback: eventCallback,
            eventTimeout: eventTimeout,
            ...variables
        });
    });
}
